export * from './domain';
export * from './testkit';
export * from './builders';
export * from './dto';
export var agentStatsUrl = '/agent/stats';
export var createChatDashboardApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/dashboard/chat");
    return {
        getTableData: function (chatDashboardDto) { return http.post("".concat(url), chatDashboardDto); },
        getDashboardOverview: function (chatDashboardOverviewDto) { return http.post("".concat(url, "/overview"), chatDashboardOverviewDto); },
        getAgentStats: function (chatDashboardBaseDto) { return http.post("".concat(url).concat(agentStatsUrl), chatDashboardBaseDto); },
        getAgentStatsNew: function (chatDashboardBaseDto) { return http.post("".concat(url).concat(agentStatsUrl, "/new"), chatDashboardBaseDto); },
    };
};
//# sourceMappingURL=index.js.map